type HubspotFormSnapshot = {
  form_id?: string;
  form_title?: string;
  form_slug?: string;
  wizard_submission_hash?: string;
  wizard_submission_url?: string;
  form_answers_summary?: string;
};

type AnswerSummaryEntry = {
  question: string;
  answer: string;
};

export const HUBSPOT_FORM_SNAPSHOT_KEY = 'hubspot_form_snapshot';
const MAX_ANSWERS_SUMMARY_LENGTH = 8000;

const sanitizeText = (value: string) =>
  value
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const truncateText = (value: string, maxLength: number) => {
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength - 3)}...`;
};

export const buildFormAnswersSummary = (entries: AnswerSummaryEntry[]) => {
  const lines = entries
    .map(({ question, answer }) => {
      const sanitizedQuestion = sanitizeText(question);
      const sanitizedAnswer = sanitizeText(answer);
      if (!sanitizedQuestion || !sanitizedAnswer) return '';
      return `${sanitizedQuestion}: ${sanitizedAnswer}`;
    })
    .filter(Boolean);

  return truncateText(lines.join('\n'), MAX_ANSWERS_SUMMARY_LENGTH);
};

export const buildWizardFormPayload = (snapshot: HubspotFormSnapshot) => {
  const lines = [
    `Form Id: ${snapshot.form_id || ''}`,
    `Form Title: ${snapshot.form_title || ''}`,
    `Form Slug: ${snapshot.form_slug || ''}`,
    '',
    'Form answers:',
    snapshot.form_answers_summary || '',
    '',
    `Wizard Submission Hash: ${snapshot.wizard_submission_hash || ''}`,
    `Wizard Submission Url: ${snapshot.wizard_submission_url || ''}`,
  ];

  return truncateText(lines.join('\n'), MAX_ANSWERS_SUMMARY_LENGTH);
};

export const setHubspotFormSnapshot = (snapshot: HubspotFormSnapshot) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(HUBSPOT_FORM_SNAPSHOT_KEY, JSON.stringify(snapshot));
};

export const getHubspotFormSnapshot = (): HubspotFormSnapshot | null => {
  if (typeof window === 'undefined') return null;

  const rawSnapshot = window.localStorage.getItem(HUBSPOT_FORM_SNAPSHOT_KEY);
  if (!rawSnapshot) return null;

  try {
    return JSON.parse(rawSnapshot) as HubspotFormSnapshot;
  } catch {
    return null;
  }
};

export const clearHubspotFormSnapshot = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(HUBSPOT_FORM_SNAPSHOT_KEY);
};

export type { HubspotFormSnapshot };
